import { IconDownload } from "@tabler/icons";
import { Button, Tooltip } from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useState } from "react";

const DownloadButton = ({ title, targetRef, onDownloadStart, onDownloadEnd }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!targetRef.current || isDownloading) return;

    setIsDownloading(true);
    onDownloadStart?.();

    try {
      const contentClone = targetRef.current.cloneNode(true);
      contentClone.style.position = 'fixed';
      contentClone.style.left = '-10000px';
      document.body.appendChild(contentClone);

      const pdf = new jsPDF("p", "mm", "a4");
      const elements = contentClone.querySelectorAll(".voucher-section");

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        Array.from(elements).forEach(el => el.style.display = 'none');
        element.style.display = 'block';

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#FFFFFF'
        });

        const imgData = canvas.toDataURL("image/png");
        const imgWidth = pdf.internal.pageSize.getWidth() - 20;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      }

      document.body.removeChild(contentClone);
      pdf.save(`${title}.pdf`);
    } catch (error) {
      console.error("PDF generation failed:", error);
    } finally {
      setIsDownloading(false);
      onDownloadEnd?.();
    }
  };

  return (
    <Tooltip title="Download PDF">
      <Button
        variant="contained"
        color="primary"
        onClick={handleDownload}
        disabled={isDownloading}
        startIcon={<IconDownload size={20} />}
      >
        Download PDF
      </Button>
    </Tooltip>
  );
};

export default DownloadButton;